export default "__VITE_ASSET__9fa59837__"